import script from "./AdminPersonnelDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPersonnelDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPersonnelDashboardView.vue?vue&type=style&index=0&id=19742ec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19742ec6"]])

export default __exports__